import { AnyAction, createSlice, Reducer, Slice } from '@reduxjs/toolkit';

import { BasicInfoStateModel } from './models/basic-info-state.model';
import { BasicInfoReducers } from './types/basic-info-reducers.type';

const initialState: BasicInfoStateModel = {
  data: null,
  hasFormError: false,
};
export const campaignBasicInfoSlice: Slice<
  BasicInfoStateModel,
  BasicInfoReducers,
  string
> = createSlice({
  name: 'basicInfo',
  initialState,
  reducers: {
    setBasicInfo(state, action) {
      state.data = action.payload;
    },
    resetBasicInfo(state) {
      Object.assign(state, initialState);
    },
    setBasicInfoError(state, action) {
      state.hasFormError = action.payload;
    },
  },
});

export const { setBasicInfo, resetBasicInfo, setBasicInfoError } =
  campaignBasicInfoSlice.actions;

const campaignBasicInfoSliceReducers: Reducer<BasicInfoStateModel, AnyAction> =
  campaignBasicInfoSlice.reducer;

export default campaignBasicInfoSliceReducers;
